// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: subscription.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";

export const protobufPackage = "com.tick2trade.api.subscription";

export interface PremiumFeature {
  category: string;
  subCategory: string;
  feature: string;
  featureCode: string;
  name: string;
  heading: string;
  description: string;
  mediaUrl?: string | undefined;
}

export interface MediaUpload {
  data: Uint8Array;
  filename: string;
}

export interface PremiumFeatureUpsertRequest {
  category: string;
  subCategory: string;
  feature: string;
  featureCode: string;
  name: string;
  heading: string;
  description: string;
  media?: MediaUpload | undefined;
  clearMedia?: boolean | undefined;
}

export interface SubscriptionFeatures {
  subscriptionPlan: string;
  premiumFeature: PremiumFeature[];
  isUserPlan: boolean;
  trialDays: number;
}

export interface SubscriptionFeatureResponse {
  subscriptionFeature: SubscriptionFeatures[];
}

export interface PremiumFeatureResponse {
  premiumFeature: PremiumFeature[];
}

export interface ManageFeatureRequest {
  subscriptionPlan: string[];
  featureCode: string;
}

export interface UserSubscriptionPlan {
  subscriptionPlan: string[];
}

function createBasePremiumFeature(): PremiumFeature {
  return {
    category: "",
    subCategory: "",
    feature: "",
    featureCode: "",
    name: "",
    heading: "",
    description: "",
    mediaUrl: undefined,
  };
}

export const PremiumFeature = {
  encode(message: PremiumFeature, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.category !== "") {
      writer.uint32(10).string(message.category);
    }
    if (message.subCategory !== "") {
      writer.uint32(18).string(message.subCategory);
    }
    if (message.feature !== "") {
      writer.uint32(26).string(message.feature);
    }
    if (message.featureCode !== "") {
      writer.uint32(34).string(message.featureCode);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.heading !== "") {
      writer.uint32(50).string(message.heading);
    }
    if (message.description !== "") {
      writer.uint32(58).string(message.description);
    }
    if (message.mediaUrl !== undefined) {
      writer.uint32(66).string(message.mediaUrl);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PremiumFeature {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePremiumFeature();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.category = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.subCategory = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.feature = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.featureCode = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.heading = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.description = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.mediaUrl = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PremiumFeature {
    return {
      category: isSet(object.category) ? globalThis.String(object.category) : "",
      subCategory: isSet(object.subCategory) ? globalThis.String(object.subCategory) : "",
      feature: isSet(object.feature) ? globalThis.String(object.feature) : "",
      featureCode: isSet(object.featureCode) ? globalThis.String(object.featureCode) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      heading: isSet(object.heading) ? globalThis.String(object.heading) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      mediaUrl: isSet(object.mediaUrl) ? globalThis.String(object.mediaUrl) : undefined,
    };
  },

  toJSON(message: PremiumFeature): unknown {
    const obj: any = {};
    if (message.category !== "") {
      obj.category = message.category;
    }
    if (message.subCategory !== "") {
      obj.subCategory = message.subCategory;
    }
    if (message.feature !== "") {
      obj.feature = message.feature;
    }
    if (message.featureCode !== "") {
      obj.featureCode = message.featureCode;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.heading !== "") {
      obj.heading = message.heading;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.mediaUrl !== undefined) {
      obj.mediaUrl = message.mediaUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PremiumFeature>, I>>(base?: I): PremiumFeature {
    return PremiumFeature.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PremiumFeature>, I>>(object: I): PremiumFeature {
    const message = createBasePremiumFeature();
    message.category = object.category ?? "";
    message.subCategory = object.subCategory ?? "";
    message.feature = object.feature ?? "";
    message.featureCode = object.featureCode ?? "";
    message.name = object.name ?? "";
    message.heading = object.heading ?? "";
    message.description = object.description ?? "";
    message.mediaUrl = object.mediaUrl ?? undefined;
    return message;
  },
};

function createBaseMediaUpload(): MediaUpload {
  return { data: new Uint8Array(0), filename: "" };
}

export const MediaUpload = {
  encode(message: MediaUpload, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }
    if (message.filename !== "") {
      writer.uint32(18).string(message.filename);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MediaUpload {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMediaUpload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.data = reader.bytes();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.filename = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MediaUpload {
    return {
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
      filename: isSet(object.filename) ? globalThis.String(object.filename) : "",
    };
  },

  toJSON(message: MediaUpload): unknown {
    const obj: any = {};
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    if (message.filename !== "") {
      obj.filename = message.filename;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MediaUpload>, I>>(base?: I): MediaUpload {
    return MediaUpload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MediaUpload>, I>>(object: I): MediaUpload {
    const message = createBaseMediaUpload();
    message.data = object.data ?? new Uint8Array(0);
    message.filename = object.filename ?? "";
    return message;
  },
};

function createBasePremiumFeatureUpsertRequest(): PremiumFeatureUpsertRequest {
  return {
    category: "",
    subCategory: "",
    feature: "",
    featureCode: "",
    name: "",
    heading: "",
    description: "",
    media: undefined,
    clearMedia: undefined,
  };
}

export const PremiumFeatureUpsertRequest = {
  encode(message: PremiumFeatureUpsertRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.category !== "") {
      writer.uint32(10).string(message.category);
    }
    if (message.subCategory !== "") {
      writer.uint32(18).string(message.subCategory);
    }
    if (message.feature !== "") {
      writer.uint32(26).string(message.feature);
    }
    if (message.featureCode !== "") {
      writer.uint32(34).string(message.featureCode);
    }
    if (message.name !== "") {
      writer.uint32(42).string(message.name);
    }
    if (message.heading !== "") {
      writer.uint32(50).string(message.heading);
    }
    if (message.description !== "") {
      writer.uint32(58).string(message.description);
    }
    if (message.media !== undefined) {
      MediaUpload.encode(message.media, writer.uint32(66).fork()).ldelim();
    }
    if (message.clearMedia !== undefined) {
      writer.uint32(72).bool(message.clearMedia);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PremiumFeatureUpsertRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePremiumFeatureUpsertRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.category = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.subCategory = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.feature = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.featureCode = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.name = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.heading = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.description = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.media = MediaUpload.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.clearMedia = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PremiumFeatureUpsertRequest {
    return {
      category: isSet(object.category) ? globalThis.String(object.category) : "",
      subCategory: isSet(object.subCategory) ? globalThis.String(object.subCategory) : "",
      feature: isSet(object.feature) ? globalThis.String(object.feature) : "",
      featureCode: isSet(object.featureCode) ? globalThis.String(object.featureCode) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      heading: isSet(object.heading) ? globalThis.String(object.heading) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      media: isSet(object.media) ? MediaUpload.fromJSON(object.media) : undefined,
      clearMedia: isSet(object.clearMedia) ? globalThis.Boolean(object.clearMedia) : undefined,
    };
  },

  toJSON(message: PremiumFeatureUpsertRequest): unknown {
    const obj: any = {};
    if (message.category !== "") {
      obj.category = message.category;
    }
    if (message.subCategory !== "") {
      obj.subCategory = message.subCategory;
    }
    if (message.feature !== "") {
      obj.feature = message.feature;
    }
    if (message.featureCode !== "") {
      obj.featureCode = message.featureCode;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.heading !== "") {
      obj.heading = message.heading;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.media !== undefined) {
      obj.media = MediaUpload.toJSON(message.media);
    }
    if (message.clearMedia !== undefined) {
      obj.clearMedia = message.clearMedia;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PremiumFeatureUpsertRequest>, I>>(base?: I): PremiumFeatureUpsertRequest {
    return PremiumFeatureUpsertRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PremiumFeatureUpsertRequest>, I>>(object: I): PremiumFeatureUpsertRequest {
    const message = createBasePremiumFeatureUpsertRequest();
    message.category = object.category ?? "";
    message.subCategory = object.subCategory ?? "";
    message.feature = object.feature ?? "";
    message.featureCode = object.featureCode ?? "";
    message.name = object.name ?? "";
    message.heading = object.heading ?? "";
    message.description = object.description ?? "";
    message.media = (object.media !== undefined && object.media !== null)
      ? MediaUpload.fromPartial(object.media)
      : undefined;
    message.clearMedia = object.clearMedia ?? undefined;
    return message;
  },
};

function createBaseSubscriptionFeatures(): SubscriptionFeatures {
  return { subscriptionPlan: "", premiumFeature: [], isUserPlan: false, trialDays: 0 };
}

export const SubscriptionFeatures = {
  encode(message: SubscriptionFeatures, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.subscriptionPlan !== "") {
      writer.uint32(10).string(message.subscriptionPlan);
    }
    for (const v of message.premiumFeature) {
      PremiumFeature.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.isUserPlan !== false) {
      writer.uint32(24).bool(message.isUserPlan);
    }
    if (message.trialDays !== 0) {
      writer.uint32(32).int32(message.trialDays);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubscriptionFeatures {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionFeatures();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.subscriptionPlan = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.premiumFeature.push(PremiumFeature.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.isUserPlan = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.trialDays = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionFeatures {
    return {
      subscriptionPlan: isSet(object.subscriptionPlan) ? globalThis.String(object.subscriptionPlan) : "",
      premiumFeature: globalThis.Array.isArray(object?.premiumFeature)
        ? object.premiumFeature.map((e: any) => PremiumFeature.fromJSON(e))
        : [],
      isUserPlan: isSet(object.isUserPlan) ? globalThis.Boolean(object.isUserPlan) : false,
      trialDays: isSet(object.trialDays) ? globalThis.Number(object.trialDays) : 0,
    };
  },

  toJSON(message: SubscriptionFeatures): unknown {
    const obj: any = {};
    if (message.subscriptionPlan !== "") {
      obj.subscriptionPlan = message.subscriptionPlan;
    }
    if (message.premiumFeature?.length) {
      obj.premiumFeature = message.premiumFeature.map((e) => PremiumFeature.toJSON(e));
    }
    if (message.isUserPlan !== false) {
      obj.isUserPlan = message.isUserPlan;
    }
    if (message.trialDays !== 0) {
      obj.trialDays = Math.round(message.trialDays);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscriptionFeatures>, I>>(base?: I): SubscriptionFeatures {
    return SubscriptionFeatures.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscriptionFeatures>, I>>(object: I): SubscriptionFeatures {
    const message = createBaseSubscriptionFeatures();
    message.subscriptionPlan = object.subscriptionPlan ?? "";
    message.premiumFeature = object.premiumFeature?.map((e) => PremiumFeature.fromPartial(e)) || [];
    message.isUserPlan = object.isUserPlan ?? false;
    message.trialDays = object.trialDays ?? 0;
    return message;
  },
};

function createBaseSubscriptionFeatureResponse(): SubscriptionFeatureResponse {
  return { subscriptionFeature: [] };
}

export const SubscriptionFeatureResponse = {
  encode(message: SubscriptionFeatureResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.subscriptionFeature) {
      SubscriptionFeatures.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubscriptionFeatureResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionFeatureResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.subscriptionFeature.push(SubscriptionFeatures.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionFeatureResponse {
    return {
      subscriptionFeature: globalThis.Array.isArray(object?.subscriptionFeature)
        ? object.subscriptionFeature.map((e: any) => SubscriptionFeatures.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SubscriptionFeatureResponse): unknown {
    const obj: any = {};
    if (message.subscriptionFeature?.length) {
      obj.subscriptionFeature = message.subscriptionFeature.map((e) => SubscriptionFeatures.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubscriptionFeatureResponse>, I>>(base?: I): SubscriptionFeatureResponse {
    return SubscriptionFeatureResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubscriptionFeatureResponse>, I>>(object: I): SubscriptionFeatureResponse {
    const message = createBaseSubscriptionFeatureResponse();
    message.subscriptionFeature = object.subscriptionFeature?.map((e) => SubscriptionFeatures.fromPartial(e)) || [];
    return message;
  },
};

function createBasePremiumFeatureResponse(): PremiumFeatureResponse {
  return { premiumFeature: [] };
}

export const PremiumFeatureResponse = {
  encode(message: PremiumFeatureResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.premiumFeature) {
      PremiumFeature.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PremiumFeatureResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePremiumFeatureResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.premiumFeature.push(PremiumFeature.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PremiumFeatureResponse {
    return {
      premiumFeature: globalThis.Array.isArray(object?.premiumFeature)
        ? object.premiumFeature.map((e: any) => PremiumFeature.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PremiumFeatureResponse): unknown {
    const obj: any = {};
    if (message.premiumFeature?.length) {
      obj.premiumFeature = message.premiumFeature.map((e) => PremiumFeature.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PremiumFeatureResponse>, I>>(base?: I): PremiumFeatureResponse {
    return PremiumFeatureResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PremiumFeatureResponse>, I>>(object: I): PremiumFeatureResponse {
    const message = createBasePremiumFeatureResponse();
    message.premiumFeature = object.premiumFeature?.map((e) => PremiumFeature.fromPartial(e)) || [];
    return message;
  },
};

function createBaseManageFeatureRequest(): ManageFeatureRequest {
  return { subscriptionPlan: [], featureCode: "" };
}

export const ManageFeatureRequest = {
  encode(message: ManageFeatureRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.subscriptionPlan) {
      writer.uint32(10).string(v!);
    }
    if (message.featureCode !== "") {
      writer.uint32(18).string(message.featureCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ManageFeatureRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManageFeatureRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.subscriptionPlan.push(reader.string());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.featureCode = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManageFeatureRequest {
    return {
      subscriptionPlan: globalThis.Array.isArray(object?.subscriptionPlan)
        ? object.subscriptionPlan.map((e: any) => globalThis.String(e))
        : [],
      featureCode: isSet(object.featureCode) ? globalThis.String(object.featureCode) : "",
    };
  },

  toJSON(message: ManageFeatureRequest): unknown {
    const obj: any = {};
    if (message.subscriptionPlan?.length) {
      obj.subscriptionPlan = message.subscriptionPlan;
    }
    if (message.featureCode !== "") {
      obj.featureCode = message.featureCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManageFeatureRequest>, I>>(base?: I): ManageFeatureRequest {
    return ManageFeatureRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManageFeatureRequest>, I>>(object: I): ManageFeatureRequest {
    const message = createBaseManageFeatureRequest();
    message.subscriptionPlan = object.subscriptionPlan?.map((e) => e) || [];
    message.featureCode = object.featureCode ?? "";
    return message;
  },
};

function createBaseUserSubscriptionPlan(): UserSubscriptionPlan {
  return { subscriptionPlan: [] };
}

export const UserSubscriptionPlan = {
  encode(message: UserSubscriptionPlan, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.subscriptionPlan) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserSubscriptionPlan {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserSubscriptionPlan();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.subscriptionPlan.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserSubscriptionPlan {
    return {
      subscriptionPlan: globalThis.Array.isArray(object?.subscriptionPlan)
        ? object.subscriptionPlan.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: UserSubscriptionPlan): unknown {
    const obj: any = {};
    if (message.subscriptionPlan?.length) {
      obj.subscriptionPlan = message.subscriptionPlan;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserSubscriptionPlan>, I>>(base?: I): UserSubscriptionPlan {
    return UserSubscriptionPlan.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserSubscriptionPlan>, I>>(object: I): UserSubscriptionPlan {
    const message = createBaseUserSubscriptionPlan();
    message.subscriptionPlan = object.subscriptionPlan?.map((e) => e) || [];
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
